const testimonials = [
  { name: "Thomas K.", location: "Riverchase, Hoover, AL", rating: 5, text: "I am a managing director at a financial services firm in Birmingham and received a last-minute invitation to a client meeting in London. My passport expired two years ago. Fast Passport Center processed my renewal in five business days. I made the meeting, closed the deal, and was back in Hoover by Friday. Professional, fast, and completely remote — I never had to leave my desk for anything other than shipping my documents.", service: "Expedited Renewal" },
  { name: "The Morrison Family", location: "Vestavia Hills, AL", rating: 5, text: "Our church mission team to Uganda had a participant sign up late with an expired passport and two children who had never had passports. We had 12 days until departure. Fast Passport Center processed the adult renewal in six days and guided us through the child passport process with the acceptance clerk. All three were on the plane with us. We absolutely could not have done it without their guidance.", service: "Family Expedited Passports" },
  { name: "Dr. Jennifer A., MD", location: "Hoover, AL", rating: 5, text: "I am a hospitalist at UAB and was invited to present at a cardiology conference in Barcelona with five weeks notice. My passport was expired. Between patient rounds and night calls, I had zero time to handle this myself. Fast Passport Center made it completely hands-off — I ordered online, shipped my documents on my lunch break, and had my passport back before my next weekend off. Exactly the kind of service physicians need.", service: "Passport Renewal" },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function HooverTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Hoover &amp; Greater Birmingham Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Hoover executives, Vestavia Hills mission teams, and UAB physicians who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic" dangerouslySetInnerHTML={{ __html: `&ldquo;${t.text}&rdquo;` }}></p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm" dangerouslySetInnerHTML={{ __html: t.name }}></p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}